var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimaryInlineLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H32V40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E459CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.287 22.3131C21.4037 22.3641 21.5402 22.3111 21.5868 22.1925C21.8535 21.5133 22 20.7738 22 20C22 16.6863 19.3137 14 16 14C15.2262 14 14.4866 14.1465 13.8075 14.4132C13.6889 14.4598 13.6359 14.5963 13.6869 14.713C13.738 14.8298 13.874 14.8826 13.9929 14.8364C14.6152 14.5944 15.2921 14.4615 16 14.4615C19.0588 14.4615 21.5385 16.9412 21.5385 20C21.5385 20.7079 21.4057 21.3848 21.1636 22.0071C21.1174 22.1259 21.1701 22.262 21.287 22.3131Z",
    fill: "#0F141A",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5952 21.5729C19.7119 21.624 19.8486 21.571 19.8932 21.4516C20.0617 20.9997 20.1538 20.5106 20.1538 20C20.1538 17.7059 18.2941 15.8462 16 15.8462C15.4894 15.8462 15.0003 15.9383 14.5484 16.1068C14.429 16.1514 14.376 16.2881 14.4271 16.4048C14.4782 16.5217 14.6142 16.5742 14.734 16.5305C15.1288 16.3863 15.5552 16.3077 16 16.3077C18.0392 16.3077 19.6923 17.9608 19.6923 20C19.6923 20.4448 19.6137 20.8712 19.4695 21.266C19.4258 21.3858 19.4783 21.5218 19.5952 21.5729Z",
    fill: "#0F141A",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7421 24.2579C14.0103 26.526 17.6544 26.5795 19.9874 24.4182C20.0809 24.3316 20.0808 24.1848 19.9907 24.0947L17.579 21.683C18.0275 21.262 18.3077 20.6637 18.3077 20C18.3077 18.7255 17.2745 17.6923 16 17.6923C15.3363 17.6923 14.738 17.9725 14.317 18.4211L11.9053 16.0093C11.8152 15.9192 11.6685 15.9192 11.5819 16.0127C9.42058 18.3456 9.474 21.9898 11.7421 24.2579Z",
    fill: "#0F141A",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryInlineLive);
export default __webpack_public_path__ + "static/media/Primary_Inline_Live.796674d68ebcaa1d456e0ede423414df.svg";
export { ForwardRef as ReactComponent };